var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 26,
    viewBox: "0 0 46 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_8111)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 26,
    rx: 2,
    fill: "#DCDFE5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.18179,
    y: 5.93335,
    width: 12.5455,
    height: 6.93333,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.18182,
    y: 17.3333,
    width: 6.27273,
    height: 1.73333,
    rx: 0.866667,
    fill: "#B3B8C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6364,
    y: 17.3333,
    width: 6.27273,
    height: 1.73333,
    rx: 0.866667,
    fill: "#B3B8C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0909,
    y: 17.3333,
    width: 6.27273,
    height: 1.73333,
    rx: 0.866667,
    fill: "#B3B8C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5455,
    y: 17.3333,
    width: 6.27273,
    height: 1.73333,
    rx: 0.866667,
    fill: "#B3B8C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_8111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 26,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.218dff78.svg";
export { ForwardRef as ReactComponent };